import { ChangeDetectionStrategy, Component } from "@angular/core";
import { OrganizationService } from "@onsip/common/services/api/resources/organization/organization.service";
import { views } from "@onsip/web/app/phone/views";
import { BehaviorSubject, map } from "rxjs";

@Component({
  selector: "onsip-migrate-sip-domain",
  templateUrl: "./migrate-sip-domain.component.html",
  styleUrls: ["./migrate-sip-domain.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MigrateSipDomainComponent {
  migratePanel$ = new BehaviorSubject<"view" | "edit">("view");
  views = views;
  isDataObtained$ = this.organizationService.state.pipe(map(({ loading }) => !loading));
  togglePanel(panel: "view" | "edit"): void {
    this.migratePanel$.next(panel);
  }

  constructor(private organizationService: OrganizationService) {}
}
